import { render, staticRenderFns } from "./PanelHeaderV2026.vue?vue&type=template&id=883fe69e&scoped=true"
import script from "./PanelHeaderV2026.vue?vue&type=script&lang=js"
export * from "./PanelHeaderV2026.vue?vue&type=script&lang=js"
import style0 from "./PanelHeaderV2026.vue?vue&type=style&index=0&id=883fe69e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883fe69e",
  null
  
)

export default component.exports